import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormInputAreaComponent} from './form-input-area.component';
import {FormInputErrorModule} from '../form-input-error/form-input-error.module';
import {InputTextareaModule} from 'primeng/inputtextarea';

@NgModule({
  declarations: [
    FormInputAreaComponent
  ],
  exports: [
    FormInputAreaComponent
  ],
  imports: [
    CommonModule,
    FormInputErrorModule,
    InputTextareaModule
  ]
})
export class FormInputAreaModule {
}
